/**
 * Custom UI translations for strings outside the video.js player.
 *
 * Keys are the English source strings (same value as the data-i18n attribute).
 * 'en' is intentionally empty — the DOM already contains the English text.
 *
 * Add a new locale by copying the 'en' block and filling in the translations.
 * To load additional locale files at runtime, call mergeCustomTranslations().
 */
export const customTranslations = {
  en: {},

  'zh-cn': {
    'Language': '语言',
    'Seek Backward 15 seconds': '后退 15 秒',
    'Seek Forward 15 seconds': '快进 15 秒',
    'Transcript': '文字记录',
    'Chapters': '章节',
    'Summary': '摘要',
    'Transcript will appear here.': '文字记录将显示在这里。',
    'Chapters will appear here.': '章节将显示在这里。',
    'Summary will appear here.': '摘要将显示在这里。',
    'Was this content useful?': '此内容对您有用吗？',
    'Yes': '是',
    'No': '否',
    'Matches': '匹配',
    'Download Transcript': '下载文字记录',
    '( AI Generated )': '（AI 生成）',
    'Transcript is currently being generated. They will be available shortly.':
      '文字记录正在生成中，即将可用。',
    'Chapters are currently being generated. They will be available shortly.':
      '章节正在生成中，即将可用。',
    'Summary is currently being generated. It will be available shortly.':
      '摘要正在生成中，即将可用。',
    'Playback confirmation!': '播放确认！',
    'Do you want to resume playing from last left location?': '您想从上次离开的地方继续播放吗？',
  },

  ja: {
    'Language': '言語',
    'Seek Backward 15 seconds': '15 秒戻る',
    'Seek Forward 15 seconds': '15 秒スキップ',
    'Transcript': 'トランスクリプト',
    'Chapters': 'チャプター',
    'Summary': '概要',
    'Transcript will appear here.': 'トランスクリプトはここに表示されます。',
    'Chapters will appear here.': 'チャプターはここに表示されます。',
    'Summary will appear here.': '概要はここに表示されます。',
    'Was this content useful?': 'このコンテンツは役に立ちましたか？',
    'Yes': 'はい',
    'No': 'いいえ',
    'Matches': '一致',
    'Download Transcript': 'トランスクリプトをダウンロード',
    '( AI Generated )': '（AI 生成）',
    'Transcript is currently being generated. They will be available shortly.':
      'トランスクリプトは現在生成中です。まもなくご利用いただけます。',
    'Chapters are currently being generated. They will be available shortly.':
      'チャプターは現在生成中です。まもなくご利用いただけます。',
    'Summary is currently being generated. It will be available shortly.':
      '概要は現在生成中です。まもなくご利用いただけます。',
    'Playback confirmation!': '再生確認！',
    'Do you want to resume playing from last left location?': '前回の再生位置から再開しますか？',
  },

  'pt-pt': {
    'Language': 'Idioma',
    'Seek Backward 15 seconds': 'Recuar 15 segundos',
    'Seek Forward 15 seconds': 'Avançar 15 segundos',
    'Transcript': 'Transcrição',
    'Chapters': 'Capítulos',
    'Summary': 'Resumo',
    'Transcript will appear here.': 'A transcrição aparecerá aqui.',
    'Chapters will appear here.': 'Os capítulos aparecerão aqui.',
    'Summary will appear here.': 'O resumo aparecerá aqui.',
    'Was this content useful?': 'Este conteúdo foi útil?',
    'Yes': 'Sim',
    'No': 'Não',
    'Matches': 'Ocorrências',
    'Download Transcript': 'Transferir transcrição',
    '( AI Generated )': '( Gerado por IA )',
    'Transcript is currently being generated. They will be available shortly.':
      'A transcrição está a ser gerada. Estará disponível em breve.',
    'Chapters are currently being generated. They will be available shortly.':
      'Os capítulos estão a ser gerados. Estarão disponíveis em breve.',
    'Summary is currently being generated. It will be available shortly.':
      'O resumo está a ser gerado. Estará disponível em breve.',
    'Playback confirmation!': 'Confirmação de reprodução!',
    'Do you want to resume playing from last left location?': 'Deseja retomar a reprodução do último local deixado?',
  },

  ko: {
    'Language': '언어',
    'Seek Backward 15 seconds': '15초 뒤로',
    'Seek Forward 15 seconds': '15초 앞으로',
    'Transcript': '스크립트',
    'Chapters': '챕터',
    'Summary': '요약',
    'Transcript will appear here.': '스크립트가 여기에 표시됩니다.',
    'Chapters will appear here.': '챕터가 여기에 표시됩니다.',
    'Summary will appear here.': '요약이 여기에 표시됩니다.',
    'Was this content useful?': '이 콘텐츠가 유용했나요?',
    'Yes': '예',
    'No': '아니요',
    'Matches': '일치',
    'Download Transcript': '스크립트 다운로드',
    '( AI Generated )': '( AI 생성 )',
    'Transcript is currently being generated. They will be available shortly.':
      '스크립트가 현재 생성 중입니다. 곧 이용 가능합니다.',
    'Chapters are currently being generated. They will be available shortly.':
      '챕터가 현재 생성 중입니다. 곧 이용 가능합니다.',
    'Summary is currently being generated. It will be available shortly.':
      '요약이 현재 생성 중입니다. 곧 이용 가능합니다.',
    'Playback confirmation!': '재생 확인!', 
    'Do you want to resume playing from last left location?': '마지막으로 중단한 위치에서 재생을 계속하시겠습니까?',
  },

  es: {
    'Language': 'Idioma',
    'Seek Backward 15 seconds': 'Retroceder 15 segundos',
    'Seek Forward 15 seconds': 'Adelantar 15 segundos',
    'Transcript': 'Transcripción',
    'Chapters': 'Capítulos',
    'Summary': 'Resumen',
    'Transcript will appear here.': 'La transcripción aparecerá aquí.',
    'Chapters will appear here.': 'Los capítulos aparecerán aquí.',
    'Summary will appear here.': 'El resumen aparecerá aquí.',
    'Was this content useful?': '¿Este contenido fue útil?',
    'Yes': 'Sí',
    'No': 'No',
    'Matches': 'Coincidencias',
    'Download Transcript': 'Descargar transcripción',
    '( AI Generated )': '( Generado por IA )',
    'Transcript is currently being generated. They will be available shortly.':
      'La transcripción se está generando. Estará disponible en breve.',
    'Chapters are currently being generated. They will be available shortly.':
      'Los capítulos se están generando. Estarán disponibles en breve.',
    'Summary is currently being generated. It will be available shortly.':
      'El resumen se está generando. Estará disponible en breve.',
    'Playback confirmation!': '¡Confirmación de reproducción!',
    'Do you want to resume playing from last left location?': '¿Desea reanudar la reproducción desde la última ubicación dejada?',
  },

  fr: {
    'Language': 'Langue',
    'Seek Backward 15 seconds': 'Reculer de 15 secondes',
    'Seek Forward 15 seconds': 'Avancer de 15 secondes',
    'Transcript': 'Transcription',
    'Chapters': 'Chapitres',
    'Summary': 'Résumé',
    'Transcript will appear here.': 'La transcription apparaîtra ici.',
    'Chapters will appear here.': 'Les chapitres apparaîtront ici.',
    'Summary will appear here.': 'Le résumé apparaîtra ici.',
    'Was this content useful?': 'Ce contenu vous a-t-il été utile ?',
    'Yes': 'Oui',
    'No': 'Non',
    'Matches': 'concordances',
    'Download Transcript': 'Télécharger la transcription',
    '( AI Generated )': '( Généré par IA )',
    'Transcript is currently being generated. They will be available shortly.':
      'La transcription est en cours de génération. Elle sera bientôt disponible.',
    'Chapters are currently being generated. They will be available shortly.':
      'Les chapitres sont en cours de génération. Ils seront bientôt disponibles.',
    'Summary is currently being generated. It will be available shortly.':
      'Le résumé est en cours de génération. Il sera bientôt disponible.',
    'Playback confirmation!': 'Confirmation de lecture !',
    'Do you want to resume playing from last left location?': 'Voulez-vous reprendre la lecture depuis le dernier emplacement laissé ?',
  },
};

/**
 * Translate a key for the given locale.
 * Falls back to the base language (e.g. 'zh' from 'zh-CN'), then returns
 * the key itself (English) when no translation is found.
 *
 * @param {string} key    - English source string (= data-i18n attribute value)
 * @param {string} locale - BCP-47 language tag (e.g. 'fr', 'zh-CN')
 * @returns {string}
 */
export function t(key, locale = 'en') {
  const dict = customTranslations[locale]
            ?? customTranslations[locale.split('-')[0]]
            ?? {};
  return dict[key] ?? key;
}

